import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class DataUtil {
    removeNullUndefined = obj => Object.entries(obj).filter(([_, v]) => v != null).reduce((acc, [k, v]) => ({ ...acc, [k]: v }), {});
}
